import { useTranslation } from 'next-i18next/pages';
import Link from 'next/link';

import { JOBS } from '@pflegia/ui/pflegia/constants/routes';
import { ContainerSection } from '@pflegia/ui/shared/container-section/ContainerSection';

interface JobTitlePageBackLinkProps {
  jobTitle: string;
  jobTitleSlug: string;
}

export const JobTitlePageBackLink: React.FC<JobTitlePageBackLinkProps> = ({ jobTitle, jobTitleSlug }) => {
  const { t } = useTranslation('jobBoard', { keyPrefix: 'internalLinkingClusters' });

  return (
    <ContainerSection className='mt-12 flex justify-center'>
      <Link className='text-primary text-lg font-medium underline' data-testid='job-title-page-back-link' href={`${JOBS}/${jobTitleSlug}`}>
        {t('allJobTitleJobsLink', { jobTitle })}
      </Link>
    </ContainerSection>
  );
};
